import { render, staticRenderFns } from "./modalCrearPremio.vue?vue&type=template&id=608496b6&scoped=true&"
import script from "./modalCrearPremio.vue?vue&type=script&lang=js&"
export * from "./modalCrearPremio.vue?vue&type=script&lang=js&"
import style0 from "./modalCrearPremio.vue?vue&type=style&index=0&id=608496b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608496b6",
  null
  
)

export default component.exports